<div *ngIf="baseHandleBarModel" [ngStyle]="contentStyle">
  <div class="d-contents" [ngStyle]="colorTextAlignStyle" [innerHTML]="baseHandleBarModel | safeHtml"></div>
</div>
